import { GridTypes } from "../utils/SchoolBlocksUtilities";
import { useGridType } from "./useGridType";
import { useStores } from "../stores/useStores";

export const useFloatingBlocksThemeLayout = () => {
  const { interfaceStore, styleStore } = useStores();
  const gridType = useGridType();

  return (
    styleStore.themeID === "2" &&
    (gridType !== GridTypes.terraced || !interfaceStore.isMainGrid)
  );
};
